import { Component, OnInit, Input } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
// import * as CryptoJS from 'crypto-js';

@Component({
    selector: 'app-patient-billing',
    templateUrl: './patient-billing.component.html',
    styleUrls: ['./patient-billing.component.scss'],
    standalone: false
})
export class PatientBillingComponent implements OnInit {
  @Input() dataForCard: Array<any>;
     @Input() bannerJson: any;
    // supportingFields: Array<any> = [];
  cardData: any;
  expandCard: boolean = false;
  // cacheObj: any;
  //  private cashCacheKey : string;
  extra_buttons: Array<any> = [];
  constructor(
    private utilService: UtilService,
    private baseService: BaseService,
    private loaderService?: LoaderService
  ) { }

  ngOnInit() {
    console.log("Data For Card is ",this.dataForCard);
    let data = this.dataForCard[0];
    if(data.patient_name == undefined){
      let griddata = {
        "filter": "admissionId:" + data.admissionId + ",uhId:" + data.uhId,
        "query_id": 'GET_PAGE'
      }
      this.getDataFromAPI(data, griddata, 'billing_details_in_patient', 'billing');
    }else{
      this.cardData = data;
    }
    // Initialize extra buttons from bannerJson
    if(this.bannerJson?.config?.extra_buttons?.buttons?.length > 0) {
      this.extra_buttons = this.bannerJson.config.extra_buttons.buttons;
    }
  }
  getDataFromAPI(data, gridData, resource, application){
    this.baseService.getWithPage(gridData, resource, application, 'GET_PAGE').subscribe(result => {
      if(result.resource && result.resource.length > 0){
        this.cardData = {...data, ...result.resource[0]};
      }else{
        this.cardData = data;
      }
      console.log("CardData ",this.cardData);
    });
  }
  expandCards(){
    if(this.expandCard){
    this.expandCard = false;
    }
    else
    this.expandCard = true;
  }
 
  getFieldValue(data: any, field: any) {
    if (!data || !field) return '';
    //  nested path (field.name)
    if (data[field.name]) {
      return data[field.name]
    }
    const value = field.name?.split('.')?.reduce((o, key) => o?.[key], data);
    if (value !== undefined && value !== null) {
      return value;
    }
    //  label (convert to key)
    const labelKey = field.label?.toLowerCase()
    return data?.[labelKey] ?? '';
  }

  extraButtonClick(btn) {
    if (btn.type == 'cash_info') {
      const args = `uhId:${this.dataForCard[0].uhId}`;
      this.loaderService.showSpinner();
      // this.baseService.get('GET_CASH_COLLECTION', args, 'user_collection_detail', 'payment').subscribe((res: any) => {
      //   this.loaderService.hideSpinner();
      //   if (res.resource && res.resource.length > 0) {
      //     if (res.resource[0]?.netAmount != undefined && res.resource[0]?.netAmount > 0) {
      //       this.dataForCard[0]['netAmount'] = res.resource[0]?.netAmount;
      //       this.cardData['netAmount'] = res.resource[0]?.netAmount;
      //     }
      //     else {
      //       this.dataForCard[0]['netAmount'] = 0;
      //       this.cardData['netAmount'] = 0;
      //     }
      //   }
      // })
      if (this.baseService != undefined) {
        this.baseService.get('GET_CONFIG', 'module_code:payment,config_code:payment_149', 'facility_config_mapping', 'facility-management').subscribe(result => {
          if (result && result.errCode == 0 && result.resource && result.resource.length > 0 && result.resource[0].config_value != undefined && result.resource[0].config_value != "") {
            // Config enabled → fetch cash collection
            this.baseService.get('GET_CASH_COLLECTION', args, 'user_collection_detail', 'payment').subscribe((res: any) => {
              this.loaderService.hideSpinner();
              if (res.resource && res.resource.length > 0) {
                if (res.resource[0]?.netAmount != undefined && res.resource[0]?.netAmount > 0) {
                  this.dataForCard[0]['netAmount'] = res.resource[0]?.netAmount
                }
                else {
                  this.dataForCard[0]['netAmount'] = 0;
                }
              }
            }, err => {
              this.loaderService.hideSpinner();
            });
          } else {
            this.loaderService.hideSpinner();
            // this.dataForCard[0]['netAmount'] = 0;
          }
        }, err => {
          this.loaderService.hideSpinner();
        });
      }
    }
  }
  
}
